import { useState } from 'react'
import { useAlert } from 'react-alert'

import { resetDocuments } from '../../../../main/usecases'

import { useOnChangeDetect, useModalBox } from '../../../contexts'
import { Button } from '../../../components'

const DeleteDocumentModal = ({ cdTypeToService, cdTypeToDocument }: any) => {
  const [loading, setLoading] = useState(false)
  const { modalClose } = useModalBox()
  const alert = useAlert()
  const { setRefresh } = useOnChangeDetect()

  const handleDeleteCustomer = async (
    cdTypeToService: number,
    cdTypeToDocument: number
  ) => {
    try {
      setLoading(true)
      await resetDocuments({
        cdTipoAvaliacao: cdTypeToService,
        cdTypeToDocument: cdTypeToDocument
      }).load()
      modalClose(true)
      alert.show('Documento personalizado deletado com sucesso', {
        type: 'success',
        timeout: 4000
      })
      setRefresh((prev: any) => !prev)
    } catch (error) {
      console.error(error)
      alert.show('Erro ao deletar o documento personalizado', {
        type: 'error',
        timeout: 4000
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="delete-modal">
      <p>Deseja realmente deletar o documento personalizado?</p>
      <div>
        <Button
          disabled={loading}
          hasredButton
          onClick={() =>
            handleDeleteCustomer(cdTypeToService, cdTypeToDocument)
          }
        >
          Sim
        </Button>
        <Button hasSecodaryButton onClick={modalClose}>
          Não
        </Button>
      </div>
    </div>
  )
}

export default DeleteDocumentModal
